module.exports = __webpack_public_path__ + "static/media/Frame_663.e76942d9.png";